// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.commonGroupsListPopup[data-v-b1790c60]{\n    font-size: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
